module.exports = __webpack_public_path__ + "img/ico-designation.26c9a66b.svg";